import React from "react";
import { PlaidConnection } from "@common/types/plaidConnection";
import { ConfirmationModal } from "@design-system/Modal/ConfirmationModal";

interface PossibleConnectionDuplicatesModalProps {
    connections: PlaidConnection[];
    onSameLogin: () => void;
    onNewLogin: () => void;
    show?: boolean;
}

export const PossibleConnectionDuplicatesModal: React.FC<
    PossibleConnectionDuplicatesModalProps
> = ({ connections, onSameLogin, onNewLogin, show }) => {
    const bankName = connections[0].bankName;

    return (
        <ConfirmationModal
            show={show}
            title={`You've already connected ${bankName}`}
            question={
                <>
                    Both choices connect these accounts. Same login reuses
                    existing account history. New login keeps them separate.
                </>
            }
            onConfirm={onNewLogin}
            onReject={onSameLogin}
            onHide={onNewLogin}
            yes="This is a new login"
            no="This is the same login"
        />
    );
};
